const FlagDK = props => (
	<svg height="28" width="28" viewBox="0 0 200 200" {...props}>
		<rect fill="#ed5565" width="200" height="200" />
		<rect fill="#fff" x="80" y="-10.74" width="40" height="221.48" />
		<rect fill="#fff" x="80" y="-10.74" width="40" height="221.48" transform="translate(200 0) rotate(90)" />
	</svg>
);

export default FlagDK;
